// extracted by mini-css-extract-plugin
module.exports = {"remainingCredits":"ClientCreditDetails_remainingCredits__1EBJ-","redirectButton":"ClientCreditDetails_redirectButton__2ae0o"};